export const safeString = value => value == null ? '' : String(value);

export const safeToProperCase = value => {
    return safeString(value).replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};
